import {
  GridApi,
  RowNode,
  ICellRendererParams,
  CellValueChangedEvent,
} from '@ag-grid-enterprise/all-modules';

type SipPrefixOccurrences = { [key: string]: number };

export const cellValueHasChanged = (event: CellValueChangedEvent): boolean =>
  event.newValue !== event.oldValue;

export const getRowData = <T>(api: GridApi): T[] => {
  const currentRowData: T[] = [];
  api.forEachNode((node: RowNode) => {
    currentRowData.push(node.data);
  });
  return currentRowData;
};

export const addNewItemToGridRowData = <T>(api: GridApi, newItem: T): T[] => {
  const newRowData: T[] = getRowData(api);

  newRowData.push(newItem);

  api.setRowData(newRowData);
  api.setFocusedCell(newRowData.length - 1, 'code');
  api.startEditingCell({
    rowIndex: newRowData.length - 1,
    colKey: 'code',
  });

  return newRowData;
};

export const isChangingColumn = (
  searchedColId: string,
  changingColEvent: CellValueChangedEvent,
): boolean => changingColEvent.column.getColId() === searchedColId;

export const updateSipPrefixOccurrencess = (
  sipPrefixOccurrencess: SipPrefixOccurrences,
  oldValue: string,
  newValue: string,
): SipPrefixOccurrences => {
  const oldOccurrences = sipPrefixOccurrencess[oldValue] || 0;
  const newOccurrences = sipPrefixOccurrencess[newValue] || 0;

  return {
    ...sipPrefixOccurrencess,
    [oldValue]: oldOccurrences - 1,
    [newValue]: newOccurrences + 1,
  };
};

export const hasRepeatedSipPrefixOccurrencesError = (accessFunctionOccurrences: {
  [key: string]: number;
}): boolean =>
  Object.keys(accessFunctionOccurrences)
    .filter((key) => !!key)
    .some((key) => accessFunctionOccurrences[key] > 1);
